import { FaUser, FaUserShield, FaUsers } from "react-icons/fa";
import type { ICellRendererParams } from "ag-grid-community";
import { Roles, type UserUserIO } from "../../../../generated/fresh-guard-api";

export default function RoleIconCellView(
  props: ICellRendererParams<UserUserIO>,
) {
  const admin = props.data?.roles?.find((role) => role === Roles.RoleAdmin);
  const supervisor = props.data?.roles?.find(
    (role) => role === Roles.RoleSupervisor,
  );
  const user = props.data?.roles?.find((role) => role === Roles.RoleUser);

  if (admin) {
    return (
      <FaUserShield style={{ color: "#cd0404" }} title={Roles.RoleAdmin} />
    );
  }

  if (supervisor) {
    return (
      <FaUsers style={{ color: "#0096FF" }} title={Roles.RoleSupervisor} />
    );
  }

  if (user) {
    return <FaUser style={{ color: "#252525" }} title={Roles.RoleUser} />;
  }

  return null;
}
